export default __webpack_public_path__ + "static/media/Group 6.9cd65220.png";